import Axios from "@/helpers/axios";
import device from "current-device";

export default {
    GET(context, data) {
        if(window.prerender){
            return;
        }
        const isMobile = device.mobile();
        return Axios.get(`/advertising/index?${data && data.location ? 'location=' + data.location : ''}${data.isUsed ? '&is_used=' + data.isUsed : ''}${isMobile?'&is_mobile=1':''}`, {
            location: data.location
        })
    },
    SEND_VIEWS_STATISTIC(context, data) {
        const key = localStorage.getItem('view_key');
        if(!data.id){
            return null;
        }
        return Axios.get(`/advertising/views?id=${data.id}${data.used ? '&is_used=1' : ''}${data.isSlider ? '&is_slider=' + data.isSlider : ''}${key?'&key='+key:''}`, {
            location: data.location
        })
    },
    SEND_STATISTIC(context, data) {
        return Axios.get(`/advertising/clicks?id=${data.id}`, {
            location: data.location
        })
    }
}